/**
 * 平滑滾動到指定錨點
 * @param {string} id - 目標元素的 ID（不含 # 符號）
 */
export const scrollToAnchor = (id) => {
  // 防止默認的錨點跳轉行為
  // 在不改變 URL 的情況下平滑滾動到目標位置
  
  const element = document.getElementById(id);
  if (element) {
    // 考慮固定導航欄的高度 (76px)
    const yOffset = -80; // 可以根據需要調整
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
    // 平滑滾動到對應位置
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

/**
 * 創建處理錨點點擊的事件處理器
 * @param {string} id - 目標元素的 ID（不含 # 符號）
 * @returns {Function} - 點擊事件處理器
 */
export const handleAnchorClick = (id) => (e) => {
  e.preventDefault(); // 阻止默認行為
  scrollToAnchor(id);
  
  // 更新 URL，但不導致頁面跳轉
  window.history.pushState(null, '', `#${id}`);
}; 